type AppConfiguration = {
  webappHost: string;
  mailsApiHost: string;
  adminApiHost: string;
  notificationsApiHost: string;
  chatsWsHost: string;
  chatsWsPath?: string;
  bucketName: string;
  region: string;
  authLambdaFunctionName: string;
  userPoolId: string;
  cognitoClientId: string;
  idp: string;
}

const configuration: AppConfiguration = {
  webappHost: process.env.REACT_APP_WEBAPP_HOST || '',
  adminApiHost: process.env.REACT_APP_ADMIN_API_HOST || '',
  mailsApiHost: process.env.REACT_APP_MAILS_API_HOST || '',
  notificationsApiHost: process.env.REACT_APP_NOTIFICATIONS_API_HOST || '',
  chatsWsHost: process.env.REACT_APP_CHATS_WS_HOST || '',
  chatsWsPath: process.env.REACT_APP_CHATS_WS_PATH,
  bucketName: process.env.REACT_APP_BUCKET_NAME || '',
  region: process.env.REACT_APP_REGION || '',
  authLambdaFunctionName: process.env.REACT_APP_AUTH_LAMBDA_FUNCTION_NAME || '',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  cognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
  idp: process.env.REACT_APP_REGION && process.env.REACT_APP_USER_POOL_ID
    ? `https://cognito-idp.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`
    : ''
}

export default configuration;